module.exports = __webpack_public_path__ + "static/media/hexagon-municipal-land.ff7f5378.svg";